import { Route, Routes } from 'react-router-dom';
import './styles/base/app.css';
import './styles/base/globals.css';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/Login';
import PrivacyConsent from './pages/PrivacyConsent';
import StepFlow from './pages/StepFlow';
import Nfc from './pages/Nfc';
import Checklist from './pages/Checklist';
import PatrolList from './pages/PatrolList';
import PatrolDetail from './pages/PatrolDetail';
import SiteRegistration from './pages/SiteRegistration';
import UserRegistration from './pages/UserRegistration';
import NFCManagement from './pages/NFCManagement';
import RecordInfo from './pages/RecordInfo';

function App() {
  const userRoutes = [
    { path: '/privacyConsent', element: <PrivacyConsent /> },
    { path: '/stepFlow', element: <StepFlow /> },
    { path: '/nfc', element: <Nfc /> },
    { path: '/checklist', element: <Checklist /> },
    { path: '/patrolList', element: <PatrolList /> },
    { path: '/patrolDetail', element: <PatrolDetail /> },
  ];

  const adminRoutes = [
    { path: '/', element: <SiteRegistration /> },
    { path: '/userRegistration', element: <UserRegistration /> },
    { path: '/nfcManagement', element: <NFCManagement /> },
    { path: '/recordInfo', element: <RecordInfo /> },
  ];

  return (
    <div className="app-container">
      <div className="content-container">
        <Routes>
          {/* 공통 */}
          <Route path="/login" element={<Login />} />

          {/* 회원 전용 */}
          {userRoutes.map(({ path, element }) => (
            <Route
              key={path}
              path={path}
              element={
                <ProtectedRoute allowedStates={['U']}>
                  <Layout>{element}</Layout>
                </ProtectedRoute>
              }
            />
          ))}

          {/* 관리자 전용 */}
          {adminRoutes.map(({ path, element }) => (
            <Route
              key={path}
              path={path}
              element={
                <ProtectedRoute allowedStates={['R']}>
                  <Layout>{element}</Layout>
                </ProtectedRoute>
              }
            />
          ))}
        </Routes>
      </div>
    </div>
  );
}

export default App;
